import Vue from 'vue'
import VueRouter from 'vue-router'
import store from "./store"
import Page1 from "./steps/Page1";
import Page2 from "./steps/Page2";
import Page3 from "./steps/Page3";
import Page4 from "./steps/Page4";
import Page21 from "./steps/Page21";

Vue.use(VueRouter);

window.dataLayer = window.dataLayer || [];

const routes = [
    {
        path: '/',
        name: 'page1',
        component: Page1,
    },
    {
        path: '/reisende',
        name: 'page2',
        component: Page2,
        beforeEnter(to, from, next) {
            window.dataLayer.push({
                'event': 'checkout',
                'ecommerce': {
                    'checkout': {
                        'actionField': {'step': 2},
                        'products': [{
                            'name': window.gtmName,
                            'id': store.state.tourId,
                            'price': store.getters.totalPrice,
                            'category': window.gtmCategory,
                            'variant': window.gtmVariant,
                            'quantity': 1
                        }]
                    }
                },
            });

            next();
        }

    },
    {
        path: '/romfordeling',
        name: 'page21',
        component: Page21,
    },
    {
        path: '/tillegg',
        name: 'page3',
        component: Page3,
        beforeEnter(to, from, next) {
            window.dataLayer.push({
                'event': 'checkout',
                'ecommerce': {
                    'checkout': {
                        'actionField': {'step': 3},
                        'products': [{
                            'name': window.gtmName,
                            'id': store.state.tourId,
                            'price': store.getters.totalPrice,
                            'category': window.gtmCategory,
                            'variant': window.gtmVariant,
                            'quantity': 1
                        }]
                    }
                },
            });

            next();
        }
    },
    {
        path: '/bekreft',
        name: 'page4',
        component: Page4,
        beforeEnter(to, from, next) {
            window.dataLayer.push({
                'event': 'checkout',
                'ecommerce': {
                    'checkout': {
                        'actionField': {'step': 4},
                        'products': [{
                            'name': window.gtmName,
                            'id': store.state.tourId,
                            'price': store.getters.totalPrice,
                            'category': window.gtmCategory,
                            'variant': window.gtmVariant,
                            'quantity': 1
                        }]
                    }
                },
            });

            window.dataLayer.push({
                'event': 'order_complete',
                'enhanced_conversion_data': {
                    "email": store.state.customer.email,
                    "phone_number": store.state.customer.mobile,
                    "address.first_name": store.state.customer.firstName,
                    "address.last_name": store.state.customer.lastName,
                    "address.street": store.state.customer.streetAddress,
                    "address.postal_code": store.state.customer.zip,
                    "address.city": store.state.customer.city,
                    "address.country": 'NO',
                }
            });

            next();
        }
    }
];

const router = new VueRouter({
    linkActiveClass: 'active',
    routes: routes,
    // Reset the scroll position to the top on every page change.
    scrollBehavior(to, from, savedPosition) {
        return {x: 0, y: 0};
    },
});

export default router
